(() => {
  const root = document.querySelector('[data-rb-root]');
  if (!root) return;
  const selects = [...document.querySelectorAll('[data-rb-select]')];
  const addButtons = [...document.querySelectorAll('[data-rb-add]')];
  const statuses = [...document.querySelectorAll('[data-rb-status]')];
  const setVariant = (id) => {
    root.dataset.variantId = id;
    selects.forEach((select) => { select.value = id; });
    const option = selects[0]?.selectedOptions[0];
    const available = option?.dataset.available === 'true';
    addButtons.forEach((button) => { button.disabled = !available; });
  };
  selects.forEach((select) => select.addEventListener('change', () => setVariant(select.value)));
  const sticky = document.querySelector('[data-rb-sticky]');
  const hero = document.querySelector('[data-rb-hero]');
  if (sticky && hero) {
    const mobile = window.matchMedia('(max-width: 640px)');
    let heroVisible = true;
    const updateSticky = () => sticky.classList.toggle('is-visible', mobile.matches || !heroVisible);
    if ('IntersectionObserver' in window) new IntersectionObserver(([entry]) => { heroVisible = entry.isIntersecting; updateSticky(); }, { threshold: .16 }).observe(hero);
    mobile.addEventListener('change', updateSticky);
    updateSticky();
  }
  addButtons.forEach((button) => button.addEventListener('click', async () => {
    const variantId = root.dataset.variantId;
    if (!variantId) return;
    const labels = addButtons.map((item) => item.innerHTML);
    addButtons.forEach((item) => { item.disabled = true; item.textContent = 'Adding…'; });
    statuses.forEach((item) => { item.textContent = ''; });
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Unable to add');
      addButtons.forEach((item) => { item.textContent = 'Added to cart'; });
      statuses.forEach((item) => { item.textContent = 'Your belt is in the cart.'; });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (_) {
      addButtons.forEach((item) => { item.textContent = 'Try again'; });
      statuses.forEach((item) => { item.textContent = 'That size could not be added. Please try another size.'; });
    } finally {
      window.setTimeout(() => {
        addButtons.forEach((item, index) => { item.innerHTML = labels[index]; });
        setVariant(root.dataset.variantId);
      }, 1800);
    }
  }));
  setVariant(root.dataset.variantId);
})();
